import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useSubscription } from '../contexts/SubscriptionContext';
import LoadingSpinner from './LoadingSpinner';

const ProtectedRoute = ({ children, requireSubscription = true, requireUsage = false }) => {
  const { currentUser, loading: authLoading } = useAuth();
  const { isSubscribed, isLoading: subscriptionLoading, isContextReady, userUsage } = useSubscription();
  const location = useLocation();
  
  // Allow access to paywall page without subscription
  const isPaywallPage = location.pathname === '/paywall';
  
  // Show loading while auth or subscription is loading
  if (authLoading || (requireSubscription && subscriptionLoading && !isContextReady)) {
    return <LoadingSpinner text="Loading..." />;
  }
  
  // Redirect to login if no user
  if (!currentUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  
  // For routes that require usage checking (note creation)
  // Block access only if they've already used their free note and try to create another
  if (requireUsage && !isSubscribed && userUsage.hasReachedLimit && !isPaywallPage) {
    return <Navigate to="/paywall" state={{ 
      from: location, 
      reason: 'usage_limit_exceeded',
      usage: userUsage 
    }} replace />;
  }
  
  // For routes that require subscription (traditional behavior)
  if (requireSubscription && !isSubscribed && !isPaywallPage) {
    return <Navigate to="/paywall" replace />;
  }
  
  return children;
};

export default ProtectedRoute;
